import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { CLAIM_STATUS } from "../../../constants/claimStatus/ClaimStatus";

const Transition = React.forwardRef(function Transition(
	props: TransitionProps & {
		children: React.ReactElement<any, any>;
	},
	ref: React.Ref<unknown>
) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export const CustomDialog = ({
	open,
	heading,
	claim_object_id,
	message,
	mode,
	handleClaimStatus,
	handleReject
}: {
	claim_object_id: string;
	open: boolean;
	mode: "MOVE" | "RESTORE";
	message: string;
	heading: string;
	handleReject: () => void;
	handleClaimStatus: (claimObjectId: string, claim_status: string) => Promise<void>;
}) => {
	const handleMove = () => {
		if (mode === "MOVE") {
			handleClaimStatus(claim_object_id, CLAIM_STATUS.expired);
		} else handleClaimStatus(claim_object_id, CLAIM_STATUS.active);
		handleReject();
	};
	return (
		<React.Fragment>
			<Dialog
				open={open}
				TransitionComponent={Transition}
				keepMounted
				onClose={handleReject}
				aria-describedby="alert-dialog-slide-description"
			>
				<DialogTitle>{heading}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-slide-description">{message}</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button variant="contained" onClick={handleMove} className="button-blue">
						Yes,{mode === "MOVE" ? "Move" : "Restore"}
					</Button>
					<Button onClick={handleReject} className="button-red">
						No
					</Button>
				</DialogActions>
			</Dialog>
		</React.Fragment>
	);
};
